export enum DictionaryPartnerStatusEnum {
  ACTIVE = 'Aktywny',
  BLOCKED = 'Zablokowany',
  REMOVED = 'Usunięty',
}

export type DictionaryModelKey = {
  [key in DictionaryCategory]: DictionaryModel[];
};

export interface DictionaryModel {
  name?: string;
  type?: string;
  applicationName?: string;
  id?: string;
}

export interface SimpleDictionaryModel {
  code: string;
  name: string;
}

export enum DictionaryCategory {
  AREA = 'AREA',
  BUSINESSPARTNERSTATUS = 'BUSINESSPARTNERSTATUS',
  CONFIRMATION_DOCUMENT = 'CONFIRMATION_DOCUMENT',
  CONFIRMATION_FACTOR = 'CONFIRMATION_FACTOR',
  PROPOSAL_STATUS = 'APPLICATIONSTATUS',
  COUNTRY = 'COUNTRY',
  INVITATION_STATUS = 'INVITATION_STATUS',
  LEGALFORM = 'LEGALFORM',
  NOTIFICATION_STATUS = 'NOTIFICATION_STATUS',
  PB_TYPE = 'PB_TYPE',
  OU_TYPE = 'OU_TYPE',
  SECURITY_LEVEL = 'SECURITY_LEVEL',
  USER_STATUS = 'USER_STATUS',
  APPLICATION_ORIGIN = 'APPLICATIONORIGIN',
  PERMISSION_PROPOSAL_STATUS = 'PERMISSION_PROPOSAL_STATUS',
  CONCESSION_TYPE = 'CONCESSION_TYPE',
  PROPOSAL_TYPE = 'PROPOSAL_TYPE',
}
